import type { TemplateChartSeries } from '@/shared/types/charts';

export const populateTemplates = (
  comparisonDateString: string,
  templateChartSeries: TemplateChartSeries[]
): TemplateChartSeries[] => {
  return templateChartSeries.map(template => {
    const temp = structuredClone(template);
    temp.symbol.transactionDate = comparisonDateString;
    return temp;
  });
};
